import LoginPage from "@/core/auth/pages/LoginPage"
import React from "react"
import { Route, Routes } from "react-router-dom"

const AuthRoutes: React.FC = () => (
  <Routes>
    <Route element={<LoginPage />} path="/" />
  </Routes>
)

export default AuthRoutes
